module.exports = __webpack_public_path__ + "static/media/icon-arrow-dwon-red.365dc997.svg";